import { namespaces } from "./i18n.constants";

export const th = {
  // [namespaces.common]: {
  //   buttons: {
  //     check_accept: "ข้าพเจ้าได้อ่านและเข้าใจเนื้อหาข้างต้นอย่างครบถ้วนแล้ว",
  //     informed: "รับทราบ",
  //   },
  // },
  [namespaces.pages.daolinv]: {
    name: "ชื่อ",
    title: "การใช้สิทธิลดหย่อนภาษีกับสรรพากร",
    title_company: "บริษัทหลักทรัพย์จัดการกองทุน ดาโอ จำกัด",
    text_descrip: "สำหรับการใช้สิทธิลดหย่อนภาษีของเงินลงทุนปีปัจจุบัน ผู้ลงทุนสามาถแจ้งความประสงค์ หรือเปลี่ยนแปลงความประสงค์ ได้จนถึงวันทำการสุดท้ายของปีปัจจุบันนั้นๆ",
    descrip_header: "การใช้สิทธิลดหย่อนภาษีกับสรรพากร",
    descrip_p1: "ตามที่กรมสรรพากรได้ออกประกาศอธิบดีกรมสรรพากร เกี่ยวกับการใช้สิทธิลดหย่อนภาษี สำหรับเงินค่าซื้อหน่วยลงทุนในกองทุน SSF หรือ RMF ตั้งแต่วันที่ 1 มกราคม 2565 เป็นต้นไป กำหนดให้ผู้ที่ประสงค์ใช้สิทธิในการลดหย่อนภาษี ในการนำส่งข้อมูล การลงทุนในกองทุนลดหย่อนภาษีของตน ต่อบริษัทหลักทรัพย์จัดการกองทุน (ผู้สนับสนุนการขาย ของ บลจ.) เท่านั้น",
    descrip_p2: "เพื่อรักษาสิทธิประโยชน์ของท่าน โปรดแจ้งความประสงค์หรือแก้ไขเปลี่ยนแปลงความประสงค์ต่อบริษัทหลักทรัพย์จัดการกองทุน ภายในวันทำการสุดท้ายของรอบปีภาษี เพื่อให้มีผลตั้งแต่รอบปีภาษีที่ท่านแจ้งไว้เป็นต้นไป",

    login_title: "กรุณากรอกข้อมูลของท่าน",
    login_text_descrip: "กรุณากรอกข้อมูล เลขบัตรประชาชน หรือ",
    login_text_descrip_p1: "เลขหนังสือเดินทาง และเบอร์มือถือในประเทศไทย",
    login_text_descrip_p2: "ที่ท่านได้ลงทะเบียนไว้ตอนเปิดบัญชี",
    login_descrip_header: "กรุณาระบุข้อมูลส่วนตัวของท่าน",
    login_cardId_placeholder: "เลขบัตรประชาชน/หนังสือเดินทาง",
    login_mobile_placeholder: "กรุณากรอกเบอร์มือถือในไทย",
    login_error_cardId: "กรุณาระบุเลขบัตรประชาชน/หนังสือเดินทาง!",
    login_error_mobile: "กรุณากรอกเบอร์มือถือในไทย!",

    popup_login_error_title: "ข้อมูลไม่ถูกต้อง",
    popup_login_error_content: "กรุณาตรวจสอบ แล้วลองใหม่อีกครั้ง",

    popup_error_title: "เกิดข้อผิดพลาด",
    popup_error_content: "กรุณาลองใหม่อีกครั้ง",

    popup_error500_title: "ข้อผิดพลาด",
    popup_error500_content: "กรุณาลองใหม่อีกครั้ง",

    otp_title: "การยืนยันตัวบุคคลด้วยรหัส OTP",
    otp_text_descrip: "ระบบได้จัดส่งรหัส OTP ไปยังเบอร์โทรศัพท์มือถือที่ท่านได้ ลงทะเบียนไว้กับบริษัทฯ กรุณาตรวจสอบกล่องข้อความเพื่อนำรหัส OTP มายืนยันตัวบุคคล",
    otp_descrip_header: "ระบบได้ส่ง OTP ไปยัง",
    otp_descrip_p1 :"เรียบร้อยแล้ว",
    otp_refCode: "เลขอ้างอิง",
    otp_error_form: "โปรดระบุรหัส OTP",
    otp_error_title: "ขออภัย",
    otp_error_wrong: "ดำเนินการไม่สำเร็จเนื่องจาก OTP ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง",

    consent_select_title: "การใช้สิทธิลดย่อนภาษีกับสรรพากร",
    consent_select_descrip: "สำหรับการใช้สิทธิลดหย่อนภาษีของปี {{year}} ลูกค้าสามารถแจ้งความประสงค์หรือเปลี่ยน แปลงความประสงค์ได้จนถึงวันทำการสุดท้ายของปี",
    consent_select_descrip_header : "เลือกช่วงเวลาการแจ้งความประสงค์ สำหรับการส่งข้อมูลการลงทุน",
    consent_select_text_invest: "(ลงทุนปี {{year}})",
    consent_select_text_back_invest: "(ลงทุนก่อนปี {{year}})",

    consent_title: "แจ้งให้ความประสงค์/ไม่ให้ความประสงค์",
    consent_text_descrip: "การแจ้งความประสงค์ในครั้งนี้ เป็นการแจ้งความประสงค์เพียงครั้งเดียว ต่อบริษัทหลักทรัพย์จัดการกองทุน จนกว่าข้าพเจ้าแจ้งเปลี่ยนความประสงค์เป็นอย่างอื่น บริษัทหลักทรัพย์จัดการกองทุน จะยึดข้อมูลการแจ้งความประสงค์ตามวันที่ล่าสุดที่ข้าพเจ้าให้ไว้",
    consent_descrip_header: "แจ้งให้ความประสงค์/ไม่ให้ความประสงค์",
    consent_descrip_p1: "เลขที่ประจำตัวผู้เสียภาษี",
    consent_descrip_p2: "ปีภาษีที่ให้นำส่งและเปิดเผยข้อมูล : ยอดซื้อปี",
    consent_descrip_p3: "เป็นต้นไป",
    consent_check_accept: "มีความประสงค์ ให้บริษัทหลักทรัพย์จัดการกองทุนดาโอ จำกัด นำส่งและเปิดเผยข้อมูลใดๆ ที่เกี่ยวกับการลงทุนในกองทุนรวมตลอดทั้งปีภาษีตั้งแต่ปีภาษีเดียวกับวันที่ข้าพเจ้าได้แจ้งความประสงค์นี้เป็นต้นไป ที่สามารถใช้สิทธิลดหย่อนภาษีได้ของข้าพเจ้าต่อกรมสรรพากร เพื่อประโยชน์ในการใช้สิทธิยกเว้นภาษีเงินได้บุคคลธรรมดาของข้าพเจ้า ทั้งนี้ ตามหลักเกณฑ์ เงื่อนไข และวิธีการที่กรมสรรพากรกำหนด",
    consent_check_deaccept: "ไม่มีความประสงค์",
    consent_check_deaccept_1:"ให้บริษัทหลักทรัพย์จัดการกองทุนดาโอ จำกัด นำส่งข้อมูลใดๆ ที่เกี่ยวกับการลงทุนในกองทุนรวมที่สามารถใช้สิทธิลดหย่อนภาษีได้ของข้าพเจ้าต่อกรมสรรพากร เพื่อประโยชน์ในการใช้สิทธิยกเว้นภาษีเงินได้บุคคลธรรมดาของข้าพเจ้า ทั้งนี้ ตามหลักเกณฑ์ เงื่อนไข และวิธีการที่กรมสรรพากรกำหนด",
    
    thanks_title: "ขอบคุณที่ท่านได้แจ้งความประสงค์",
    thanks_text_descrip: "ทางบริษัทหลักทรัพย์จัดการกองทุน ดาโอ จำกัด ได้รับความการแจ้งประสงค์ของท่านเรียบร้อยแล้ว",
    thanks_descrip_header: "บลจ. ได้รับการแจ้งความประสงค์ของท่านเรียบร้อย",
    thanks_descrip_p1: "ท่าน",
    thanks_descrip_p2: "ให้บริษัทหลักทรัพย์จัดการกองทุน ดาโอ จำกัด นำส่งข้อมูลใด ๆ ที่เกี่ยวกับการลงทุนของท่านแก่กรมสรรพากร",
    thanks_descrip_p3: "มีความประสงค์",
    thanks_descrip_p4: "ไม่มีความประสงค์",

    check_accept: "ข้าพเจ้าได้อ่านและเข้าใจเนื้อหาข้างต้นอย่างครบถ้วนแล้ว",
    btn_login: "เข้าสู่ระบบ",
    btn_informed: "รับทราบ",
    btn_next: "ถัดไป",
    btn_confirm: "ยืนยัน",
    btn_backto_home: "กลับสู่หน้าหลัก",
    btn_otp: "ขอรหัส OTP อีกครั้ง",
  },
  [namespaces.pages.daolSecKyc]: {
    title: "ทบทวนข้อมูล KYC",
    text_descrip: "บริษัทหลักทรัพย์ ดาโอ (ประเทศไทย) จำกัด (มหาชน)",
    descrip_p1: "ขั้นตอนการทบทวนข้อมูล KYC",
    descrip_p2: "กรอกหมายเลขบัตรประชาชน (สำหรับลูกค้าคนไทย)",
    descrip_p3: "ยืนยันตัวตนด้วย SMS OTP (สำหรับลูกค้าคนไทย)",
    descrip_p4: "พิสูจน์และยืนยันตัวตนทางดิจิทัล (DOPA)",
    descrip_p5: "ทบทวนข้อมูล KYC",
    descrip_p4_remark: "*กรณีที่ยังไม่เคยผ่านการยืนยันตัวตน หรือบัตรหมดอายุ",
    descrip_remark: "*กรุณาเตรียมบัตรประชาชน ของท่านให้พร้อมก่อนดำเนินการ",
    descrip_p1_eng: "กรอกวันเดือนปีเกิด (สำหรับลูกค้าต่างชาติ)",

    login_text_descrip: "กรุณาระบุตัวตนด้วยหมายเลขบัตรประชาชน 13 หลัก ที่ลงทะเบียนไว้กับทางบริษัทฯ",
    login_label_cardId: "เลขบัตรประชาชน",
    login_cardId_placeholder: "โปรดระบุ",

    login_text_date_descrip: "กรุณาระบุตัวตนของท่านด้วย วัน เดือน ปีเกิด (ค.ศ.)",

    otp_descrip_p1: "ระบบจัดส่ง OTP ไปยังเบอร์โทรศัพท์ที่ลงทะเบียนไว้กับทางบริษัทฯ หมายเลข ",

    popup_login_error_title: "แจ้งเตือนข้อมูลไม่ถูกต้อง",
    popup_login_error_content: "เลขบัตรประชาชนไม่ถูกต้อง",
    popup_login_error_title_mobile: "ขออภัย",
    popup_login_error_content_mobile: "ไม่พบหมายเลขโทรศัพท์ของท่านในฐานข้อมูล กรุณาติดต่อผู้แนะนำการลงทุนของท่าน เพื่ออัปเดตหมายเลขโทรศัพท์",

    popup_login_date_error_content: "วัน/เดือน/ปีเกิด ไม่ถูกต้อง",

    popup_otp_error_title: "ขออภัย",
    popup_otp_error_content: "ดำเนินการไม่สำเร็จเนื่องจาก OTP ไม่ถูกต้อง",

    popup_otp_lock_content: "กรุณาทำรายการใหม่อีกครั้ง หลังจากครบ 5 นาที",
  
    otp_refCode: "หมายเลขอ้างอิง",
    otp_remark: "หากต้องการเปลี่ยนแปลงเบอร์ กรุณาติดต่อผู้แนะนำการลงทุนของท่าน",

    popup_error500_title: "ข้อผิดพลาด",
    popup_error500_content: "กรุณาลองใหม่อีกครั้ง",

    popup_error_title: "ข้อผิดพลาด",
    popup_error_content: "กรุณาลองใหม่อีกครั้ง",

    loading: "กรุณารอสักครู่",

    success: "สำเร็จ ข้อมูลของท่านถูกต้อง",

    btn_otp: "ขอรหัส OTP ใหม่",
    btn_next: "ต่อไป",
    btn_again: "ลองใหม่อีกครั้ง",
    btn_ok: "ตกลง",
  },
  [namespaces.pages.daolinvNdid]: {
    title: "พิสูจน์การยืนยันตัวตนทางดิจิทัล (NDID)",
    text_descrip: "บริษัทหลักทรัพย์จัดการกองทุน ดาโอ จำกัด",
    descrip_p1: "ขั้นตอนการพิสูจน์การยืนยันตัวตนทางดิจิทัล (NDID)",
    descrip_p2: "กรอกหมายเลขบัตรประชาชน",
    descrip_p3: "ยืนยันตัวตนด้วย SMS OTP",
    descrip_p4: "การคุ้มครองข้อมูลผู้ใช้งาน",
    descrip_p5: "พิสูจน์และยืนยันตัวตนทางดิจิทัล (DOPA)",
    descrip_p6: "ข้อตกลงและเงื่อนไขการเชื่อมต่อ NDID",
    descrip_p7: "ยืนยันตัวตนทางดิจิทัล (NDID)",
    descrip_remark: "*กรุณาเตรียมบัตรประชาชน ของท่านให้พร้อมก่อนดำเนินการ",
    descrip_p1_eng: "กรอกวันเดือนปีเกิด (สำหรับลูกค้าต่างชาติ)",

    login_text_descrip: "กรุณาระบุตัวตนด้วยหมายเลขบัตรประชาชน 13 หลัก ที่ลงทะเบียนไว้กับทางบริษัทฯ",
    login_label_cardId: "เลขบัตรประชาชน",
    login_cardId_placeholder: "โปรดระบุ",
    
    token_undefine_title: "ไม่สามารถทำรายการได้",
    token_undefine: "กรุณาทำรายการผ่าน Link ที่ท่านได้รับจาก E-mail",

    login_text_date_descrip: "กรุณาระบุตัวตนของท่านด้วย วัน เดือน ปีเกิด (ค.ศ.)",

    otp_descrip_p1: "ระบบจัดส่ง OTP ไปยังเบอร์โทรศัพท์ที่ลงทะเบียนไว้กับทางบริษัทฯ หมายเลข ",

    popup_login_error_title: "แจ้งเตือนข้อมูลไม่ถูกต้อง",
    popup_login_error_content: "เลขบัตรประชาชนไม่ถูกต้อง",
    popup_login_error_title_mobile: "ขออภัย",
    popup_login_error_content_mobile: "ไม่พบหมายเลขโทรศัพท์ของท่านในฐานข้อมูล กรุณาติดต่อผู้แนะนำการลงทุนของท่าน เพื่ออัปเดตหมายเลขโทรศัพท์",

    popup_login_date_error_content: "วัน/เดือน/ปีเกิด ไม่ถูกต้อง",

    popup_otp_error_title: "ขออภัย",
    popup_otp_error_content: "ดำเนินการไม่สำเร็จเนื่องจาก OTP ไม่ถูกต้อง",
    popup_otp_lock_content: "กรุณาทำรายการใหม่อีกครั้ง หลังจากครบ 5 นาที",
  
    otp_refCode: "หมายเลขอ้างอิง",
    otp_remark: "หากต้องการเปลี่ยนแปลงเบอร์ กรุณาติดต่อผู้แนะนำการลงทุนของท่าน",
    popup_error500_title: "ข้อผิดพลาด",
    popup_error500_content: "กรุณาลองใหม่อีกครั้ง",

    popup_error_title: "ข้อผิดพลาด",
    popup_error_content: "กรุณาลองใหม่อีกครั้ง",

    loading: "กรุณารอสักครู่",
    success: "สำเร็จ ข้อมูลของท่านถูกต้อง",

    btn_otp: "ขอรหัส OTP ใหม่",
    btn_next: "ต่อไป",
    btn_again: "ลองใหม่อีกครั้ง",
    btn_ok: "ตกลง",
  },
  [namespaces.pages.daolsecNdid]: {
    title: "พิสูจน์การยืนยันตัวตนทางดิจิทัล (NDID)",
    text_descrip: "บริษัทหลักทรัพย์ ดาโอ (ประเทศไทย) จำกัด (มหาชน)",
    descrip_p1: "ขั้นตอนการพิสูจน์การยืนยันตัวตนทางดิจิทัล (NDID)",
    descrip_p2: "กรอกหมายเลขบัตรประชาชน",
    descrip_p3: "ยืนยันตัวตนด้วย SMS OTP",
    descrip_p4: "การคุ้มครองข้อมูลผู้ใช้งาน",
    descrip_p5: "พิสูจน์และยืนยันตัวตนทางดิจิทัล (DOPA)",
    descrip_p6: "ข้อตกลงและเงื่อนไขการเชื่อมต่อ NDID",
    descrip_p7: "ยืนยันตัวตนทางดิจิทัล (NDID)",
    descrip_remark: "*กรุณาเตรียมบัตรประชาชน ของท่านให้พร้อมก่อนดำเนินการ",
    descrip_p1_eng: "กรอกวันเดือนปีเกิด (สำหรับลูกค้าต่างชาติ)",

    login_text_descrip: "กรุณาระบุตัวตนด้วยหมายเลขบัตรประชาชน 13 หลัก ที่ลงทะเบียนไว้กับทางบริษัทฯ",
    login_label_cardId: "เลขบัตรประชาชน",
    login_cardId_placeholder: "โปรดระบุ",
    
    token_undefine_title: "ไม่สามารถทำรายการได้",
    token_undefine: "กรุณาทำรายการผ่าน Link ที่ท่านได้รับจาก E-mail",

    login_text_date_descrip: "กรุณาระบุตัวตนของท่านด้วย วัน เดือน ปีเกิด (ค.ศ.)",

    otp_descrip_p1: "ระบบจัดส่ง OTP ไปยังเบอร์โทรศัพท์ที่ลงทะเบียนไว้กับทางบริษัทฯ หมายเลข ",

    popup_login_error_title: "แจ้งเตือนข้อมูลไม่ถูกต้อง",
    popup_login_error_content: "เลขบัตรประชาชนไม่ถูกต้อง",
    popup_login_error_title_mobile: "ขออภัย",
    popup_login_error_content_mobile: "ไม่พบหมายเลขโทรศัพท์ของท่านในฐานข้อมูล กรุณาติดต่อผู้แนะนำการลงทุนของท่าน เพื่ออัปเดตหมายเลขโทรศัพท์",

    popup_login_date_error_content: "วัน/เดือน/ปีเกิด ไม่ถูกต้อง",

    popup_otp_error_title: "ขออภัย",
    popup_otp_error_content: "ดำเนินการไม่สำเร็จเนื่องจาก OTP ไม่ถูกต้อง",
    popup_otp_lock_content: "กรุณาทำรายการใหม่อีกครั้ง หลังจากครบ 5 นาที",
  
    otp_refCode: "หมายเลขอ้างอิง",
    otp_remark: "หากต้องการเปลี่ยนแปลงเบอร์ กรุณาติดต่อผู้แนะนำการลงทุนของท่าน",
    popup_error500_title: "ข้อผิดพลาด",
    popup_error500_content: "กรุณาลองใหม่อีกครั้ง",

    popup_error_title: "ข้อผิดพลาด",
    popup_error_content: "กรุณาลองใหม่อีกครั้ง",

    loading: "กรุณารอสักครู่",
    success: "สำเร็จ ข้อมูลของท่านถูกต้อง",

    btn_otp: "ขอรหัส OTP ใหม่",
    btn_next: "ต่อไป",
    btn_again: "ลองใหม่อีกครั้ง",
    btn_ok: "ตกลง",
  },
  [namespaces.pages.daolinvReviewSuitAndKyc]: {
    title: "ทบทวนข้อมูลลูกค้า",
    title_en: "Review Information",
    company: "บริษัทหลักทรัพย์จัดการกองทุน ดาโอ จำกัด",
    company_en: "DAOL INVESTMENT MANAGEMENT COMPANY LIMITED",
    descrip_p1: "การเตรียมข้อมูลสำหรับทบทวนข้อมูล",
    descrip_p2: "ข้อมูลบัตรประชาชน (สำหรับลูกค้าคนไทย)",
    descrip_p3: "โทรศัพท์มือถือที่ให้ข้อมูลไว้ เพื่อรับ SMS OTP (สำหรับลูกค้าคนไทย)",
    
    descrip_p4: "Preparing data for review",
    descrip_p5: "Date of birth information (Foreign Customer)",
    descrip_p6: "พิสูจน์และยืนยันตัวตนทางดิจิทัล (DOPA)",
    descrip_p6_remark: "*กรณีที่ยังไม่เคยผ่านการยืนยันตัวตน หรือบัตรหมดอายุ",
    descrip_remark: "*กรุณาเตรียมตามข้อความข้างต้นก่อนดำเนินการ",

    descrip_remark_en: "*Please prepare according to the above message before proceeding",
    descrip_p1_eng: "กรอกวันเดือนปีเกิด (สำหรับลูกค้าต่างชาติ)",

    login_text_descrip: "กรุณาระบุตัวตนด้วยหมายเลขบัตรประชาชน 13 หลัก ที่ลงทะเบียนไว้กับทางบริษัทฯ",
    login_label_cardId: "เลขบัตรประชาชน",
    login_cardId_placeholder: "โปรดระบุ",

    login_text_date_descrip: "กรุณาระบุตัวตนของท่านด้วย วัน เดือน ปีเกิด (ค.ศ.)",

    otp_descrip_p1: "ระบบจัดส่ง OTP ไปยังเบอร์โทรศัพท์ที่ลงทะเบียนไว้กับทางบริษัทฯ หมายเลข ",

    popup_login_error_title: "แจ้งเตือนข้อมูลไม่ถูกต้อง",
    popup_login_error_content: "เลขบัตรประชาชนไม่ถูกต้อง",
    popup_login_error_title_mobile: "ขออภัย",
    popup_login_error_content_mobile: "ไม่พบหมายเลขโทรศัพท์ของท่านในฐานข้อมูล กรุณาติดต่อผู้แนะนำการลงทุนของท่าน เพื่ออัปเดตหมายเลขโทรศัพท์",

    popup_login_date_error_content: "วัน/เดือน/ปีเกิด ไม่ถูกต้อง",

    popup_otp_error_title: "ขออภัย",
    popup_otp_error_content: "ดำเนินการไม่สำเร็จเนื่องจาก OTP ไม่ถูกต้อง",

    popup_otp_lock_content: "กรุณาทำรายการใหม่อีกครั้ง หลังจากครบ 5 นาที",
  
    otp_refCode: "หมายเลขอ้างอิง",
    otp_remark: "หากต้องการเปลี่ยนแปลงเบอร์ กรุณาติดต่อผู้แนะนำการลงทุนของท่าน",

    popup_error500_title: "ข้อผิดพลาด",
    popup_error500_content: "กรุณาลองใหม่อีกครั้ง",

    popup_error_title: "ข้อผิดพลาด",
    popup_error_content: "กรุณาลองใหม่อีกครั้ง",

    loading: "กรุณารอสักครู่",

    success: "สำเร็จ ข้อมูลของท่านถูกต้อง",

    btn_otp: "ขอรหัส OTP ใหม่",
    btn_next: "ต่อไป",
    btn_again: "ลองใหม่อีกครั้ง",
    btn_ok: "ตกลง",
  },
};


export const en = {
  // [namespaces.common]: {
  //   buttons: {
  //     check_accept: "Accept",
  //     informed: "รับทราบ",
  //   },
  // },
  [namespaces.pages.daolinv]: {
    welcome: "DaolInv",
    title: "การใช้สิทธิลดหย่อนภาษีกับสรรพากร",
    title_company: "บริษัทหลักทรัพย์จัดการกองทุน ดาโอ จำกัด",
    text_descrip: "สำหรับการใช้สิทธิลดหย่อนภาษีชองปี 2565 ลูกค้าสามารถแจ้งความประสงค์หรือเปลี่ยนแปลงความประสงค์ ได้จนถึงวันทำการสุดท้ายของปี",
    descrip_header: "การใช้สิทธิลดหย่อนภาษีกับสรรพากร",
    descrip_p1: "ตามที่กรมสรรพากรได้ออกประกาศอธิบดีกรมสรรพากร เกี่ยวกับการใช้สิทธิลดหย่อนภาษี สำหรับเงินค่าซื้อหน่วยลงทุนในกองทุน SSF หรือ RMF ตั้งแต่วันที่ 1 มกราคม 2565 เป็นต้นไป กำหนดให้ผู้ที่ประสงค์ใช้สิทธิในการลดหย่อนภาษี จะต้องแจ้งความประสงค์ในการส่งข้อมูลการซื้อหน่วยลงทุนของตน ต่อบริษัทหลักทรัพย์จัดการกองทุน (ผู้สนับสนุนการขาย ของ บลจ.) เท่านั้น",
    descrip_p2: "เพื่อรักษาสิทธิประโยชน์ของท่าน โปรดแจ้งความประสงค์หรือแก้ไขเปลี่ยนแปลงความประสงค์ต่อบริษัทหลักทรัพย์จัดการกองทุน ภายในวันทำการสุดท้ายของรอบปีภาษี เพื่อให้มีผลตั้งแต่รอบปีภาษีที่ท่านแจ้งไว้เป็นต้นไป",

    login_title: "กรุณากรอกข้อมูลของท่าน",
    login_text_descrip: "กรุณากรอกข้อมูล เลขบัตรประชาชน หรือ",
    login_text_descrip_p1: "เลขหนังสือเดินทาง และเบอร์มือถือในประเทศไทย",
    login_text_descrip_p2: "ที่ท่านได้ลงทะเบียนไว้ตอนเปิดบัญชี",
    login_descrip_header: "กรุณาระบุข้อมูลส่วนตัวของท่าน",
    login_cardId_placeholder: "เลขบัตรประชาชน/หนังสือเดินทาง",
    login_mobile_placeholder: "กรุณากรอกเบอร์มือถือในไทย",
    login_error_cardId: "กรุณาระบุเลขบัตรประชาชน/หนังสือเดินทาง!",
    login_error_mobile: "กรุณากรอกเบอร์มือถือในไทย!",

    popup_login_error_title: "ข้อมูลไม่ถูกต้อง",
    popup_login_error_content: "กรุณาตรวจสอบ แล้วลองใหม่อีกครั้ง",

    popup_error_title: "เกิดข้อผิดพลาด",
    popup_error_content: "กรุณาลองใหม่อีกครั้ง",

    popup_error500_title: "ข้อผิดพลาด",
    popup_error500_content: "กรุณาลองใหม่อีกครั้ง",

    otp_title: "การยืนยันตัวบุคคลด้วยรหัส OTP",
    otp_text_descrip: "ระบบได้จัดส่งรหัส OTP ไปยังเบอร์โทรศัพท์มือถือที่ท่านได้ ลงทะเบียนไว้กับบริษัทฯ กรุณาตรวจสอบกล่องข้อความเพื่อนำรหัส OTP มายืนยันตัวบุคคล",
    otp_descrip_header: "ระบบได้ส่ง OTP ไปยัง",
    otp_descrip_p1 :"เรียบร้อยแล้ว",
    otp_refCode: "เลขอ้างอิง",
    otp_error_form: "โปรดระบุรหัส OTP",
    otp_error_title: "ขออภัย",
    otp_error_wrong: "ดำเนินการไม่สำเร็จเนื่องจาก OTP ไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง",

    consent_title: "แจ้งให้ความประสงค์/ไม่ให้ความประสงค์",
    consent_text_descrip: "การแจ้งความประสงค์ในครั้งนี้ เป็นการแจ้งความประสงค์เพียงครั้งเดียว ต่อบริษัทหลักทรัพย์จัดการกองทุน จนกว่าข้าพเจ้าแจ้งเปลี่ยนความประสงค์เป็นอย่างอื่น บริษัทหลักทรัพย์จัดการกองทุน จะยึดข้อมูลการแจ้งความประสงค์ตามวันที่ล่าสุดที่ข้าพเจ้าให้ไว้",
    consent_descrip_header: "แจ้งให้ความประสงค์/ไม่ให้ความประสงค์",
    consent_descrip_p1: "เลขที่ประจำตัวผู้เสียภาษี",
    consent_descrip_p2: "ปีภาษีที่ให้นำส่งและเปิดเผยข้อมูล : ยอดซื้อปี",
    consent_descrip_p3: "เป็นต้นไป",
    consent_check_accept: "มีความประสงค์ ให้บริษัทหลักทรัพย์จัดการกองทุนดาโอ จำกัด นำส่งและเปิดเผยข้อมูลใดๆ ที่เกี่ยวกับการลงทุนในกองทุนรวมตลอดทั้งปีภาษีตั้งแต่ปีภาษีเดียวกับวันที่ข้าพเจ้าได้แจ้งความประสงค์นี้เป็นต้นไป ที่สามารถใช้สิทธิลดหย่อนภาษีได้ของข้าพเจ้าต่อกรมสรรพากร เพื่อประโยชน์ในการใช้สิทธิยกเว้นภาษีเงินได้บุคคลธรรมดาของข้าพเจ้า ทั้งนี้ ตามหลักเกณฑ์ เงื่อนไข และวิธีการที่กรมสรรพากรกำหนด",
    consent_check_deaccept: "ไม่มีความประสงค์",
    consent_check_deaccept_1:"ให้บริษัทหลักทรัพย์จัดการกองทุนดาโอ จำกัด นำส่งข้อมูลใดๆ ที่เกี่ยวกับการลงทุนในกองทุนรวมที่สามารถใช้สิทธิลดหย่อนภาษีได้ของข้าพเจ้าต่อกรมสรรพากร เพื่อประโยชน์ในการใช้สิทธิยกเว้นภาษีเงินได้บุคคลธรรมดาของข้าพเจ้า ทั้งนี้ ตามหลักเกณฑ์ เงื่อนไข และวิธีการที่กรมสรรพากรกำหนด",
    
    consent_select_title: "การใช้สิทธิลดย่อนภาษีกับสรรพากร",
    consent_select_descrip: "สำหรับการใช้สิทธิลดหย่อนภาษีของปี {{year}} ลูกค้าสามารถแจ้งความประสงค์หรือเปลี่ยน แปลงความประสงค์ได้จนถึงวันทำการสุดท้าย ของปี",
    consent_select_descrip_header : "เลือกช่วงเวลาการแจ้งความประสงค์ สำหรับการส่งข้อมูลการลงทุน",
    consent_select_text_invest: "(ลงทุนปี {{year}})",
    consent_select_text_back_invest: "(ลงทุนก่อนปี {{year}})",

    thanks_title: "ขอบคุณที่ท่านได้แจ้งความประสงค์",
    thanks_text_descrip: "ทางบริษัทหลักทรัพย์จัดการกองทุน ดาโอ จำกัด ได้รับการแจ้งความประสงค์ของท่านเรียบร้อยแล้ว",
    thanks_descrip_header: "บลจ. ได้รับการแจ้งความประสงค์ของท่านเรียบร้อย",
    thanks_descrip_p1: "ท่าน",
    thanks_descrip_p2: "ให้บริษัทหลักทรัพย์จัดการกองทุน ดาโอ จำกัด นำส่งข้อมูลใด ๆ ที่เกี่ยวกับการลงทุนของท่านแก่กรมสรรพากร",
    thanks_descrip_p3: "มีความประสงค์",
    thanks_descrip_p4: "ไม่มีความประสงค์",

    check_accept: "ข้าพเจ้าได้อ่านและเข้าใจเนื้อหาข้างต้นอย่างครบถ้วนแล้ว",
    btn_login: "เข้าสู่ระบบ",
    btn_informed: "รับทราบ",
    btn_next: "ถัดไป",
    btn_confirm: "ยืนยัน",
    btn_backto_home: "กลับสู่หน้าหลัก",
    btn_otp: "ขอรหัส OTP อีกครั้ง",

  },

  [namespaces.pages.daolSecKyc]: {
    title: "KYC Review",
    text_descrip: "DAOL Securities (Thailand) Public Company Limited.",
    descrip_p1: "Steps of KYC review",
    descrip_p2: "Input your ID card (Thai)",
    descrip_p3: "Identity verification via SMS OTP (For Thai only)",
    descrip_p4: "Thai ID card verification via DOPA (For Thai only)",
    descrip_p5: "KYC review",
    descrip_remark: "*Please prepare your ID card or passport before proceeding.",

    descrip_p1_eng: "Input your Birthdate (Foreigner)",

    login_text_descrip: "Please input your Thai 13-digit ID card No. that registered with DAOL SEC.",
    login_label_cardId: "ID card.",
    login_cardId_placeholder: "Please specify",

    login_text_date_descrip: "Please identify yourself with your birthdate (B.C)",

    otp_descrip_p1: "an OTP has been sent to your regsitered mobile phone number. ",

    popup_login_error_title: "Information is invalid!",
    popup_login_error_content: "Invalid ID card.",
    popup_login_error_title_mobile: "Sorry",
    popup_login_error_content_mobile: "This mobile phone number is not registered on our system, please contact your investment consultant to update your mobile phone number.",

    popup_login_date_error_content: "Invalid birthdate",

    popup_otp_error_title: "Sorry",
    popup_otp_error_content: "Invalid OTP,  the verification is  failed",
    popup_otp_lock_content: "Please try again after 5 minutes.",
    
    otp_refCode: "ref. no.:",
    otp_remark: "If the registered mobile phone number is not your current one, please contact your investment consaltant to update your mobile phone number.",

    popup_error500_title: "Error",
    popup_error500_content: "Try again",

    popup_error_title: "Error",
    popup_error_content: "Try again",

    success: "Success Your information is valid",
    loading: "Please wait",

    btn_otp: "Request new OTP",
    btn_next: "Next",
    btn_again: "Please try again",
    btn_ok: "OK",
  },
  
  [namespaces.pages.daolsecNdid]: {
    title: "พิสูจน์การยืนยันตัวตนทางดิจิทัล (NDID)",
    text_descrip: "บริษัทหลักทรัพย์ ดาโอ (ประเทศไทย) จำกัด (มหาชน)",
    descrip_p1: "ขั้นตอนการพิสูจน์การยืนยันตัวตนทางดิจิทัล (NDID)",
    descrip_p2: "กรอกหมายเลขบัตรประชาชน",
    descrip_p3: "ยืนยันตัวตนด้วย SMS OTP",
    descrip_p4: "การคุ้มครองข้อมูลผู้ใช้งาน",
    descrip_p5: "พิสูจน์และยืนยันตัวตนทางดิจิทัล (DOPA)",
    descrip_p6: "ข้อตกลงและเงื่อนไขการเชื่อมต่อ NDID",
    descrip_p7: "ยืนยันตัวตนทางดิจิทัล (NDID)",
    descrip_remark: "*กรุณาเตรียมบัตรประชาชน ของท่านให้พร้อมก่อนดำเนินการ",
    descrip_p1_eng: "กรอกวันเดือนปีเกิด (สำหรับลูกค้าต่างชาติ)",

    login_text_descrip: "กรุณาระบุตัวตนด้วยหมายเลขบัตรประชาชน 13 หลัก ที่ลงทะเบียนไว้กับทางบริษัทฯ",
    login_label_cardId: "เลขบัตรประชาชน",
    login_cardId_placeholder: "โปรดระบุ",
    
    token_undefine_title: "ไม่สามารถทำรายการได้",
    token_undefine: "กรุณาทำรายการผ่าน Link ที่ท่านได้รับจาก E-mail",

    login_text_date_descrip: "กรุณาระบุตัวตนของท่านด้วย วัน เดือน ปีเกิด (ค.ศ.)",

    otp_descrip_p1: "ระบบจัดส่ง OTP ไปยังเบอร์โทรศัพท์ที่ลงทะเบียนไว้กับทางบริษัทฯ หมายเลข ",

    popup_login_error_title: "แจ้งเตือนข้อมูลไม่ถูกต้อง",
    popup_login_error_content: "เลขบัตรประชาชนไม่ถูกต้อง",
    popup_login_error_title_mobile: "ขออภัย",
    popup_login_error_content_mobile: "ไม่พบหมายเลขโทรศัพท์ของท่านในฐานข้อมูล กรุณาติดต่อผู้แนะนำการลงทุนของท่าน เพื่ออัปเดตหมายเลขโทรศัพท์",

    popup_login_date_error_content: "วัน/เดือน/ปีเกิด ไม่ถูกต้อง",

    popup_otp_error_title: "ขออภัย",
    popup_otp_error_content: "ดำเนินการไม่สำเร็จเนื่องจาก OTP ไม่ถูกต้อง",
    popup_otp_lock_content: "กรุณาทำรายการใหม่อีกครั้ง หลังจากครบ 5 นาที",
  
    otp_refCode: "หมายเลขอ้างอิง",
    otp_remark: "หากต้องการเปลี่ยนแปลงเบอร์ กรุณาติดต่อผู้แนะนำการลงทุนของท่าน",
    popup_error500_title: "ข้อผิดพลาด",
    popup_error500_content: "กรุณาลองใหม่อีกครั้ง",

    popup_error_title: "ข้อผิดพลาด",
    popup_error_content: "กรุณาลองใหม่อีกครั้ง",

    loading: "กรุณารอสักครู่",
    success: "สำเร็จ ข้อมูลของท่านถูกต้อง",

    btn_otp: "ขอรหัส OTP ใหม่",
    btn_next: "ต่อไป",
    btn_again: "ลองใหม่อีกครั้ง",
    btn_ok: "ตกลง",
  },

  [namespaces.pages.daolinvReviewSuitAndKyc]: {
    title: "KYC Review",
    text_descrip: "DAOL INVESTMENT MANAGEMENT COMPANY LIMITED.",
    descrip_p1: "Steps of KYC review",
    descrip_p2: "Input your ID card (Thai)",
    descrip_p3: "Identity verification via SMS OTP (For Thai only)",
    descrip_p4: "Thai ID card verification via DOPA (For Thai only)",
    descrip_p5: "KYC review",
    descrip_remark: "*Please prepare your ID card or passport before proceeding.",

    descrip_p1_eng: "Input your Birthdate (Foreigner)",

    login_text_descrip: "Please input your Thai 13-digit ID card No. that registered with DAOL SEC.",
    login_label_cardId: "ID card.",
    login_cardId_placeholder: "Please specify",

    login_text_date_descrip: "Please identify yourself with your birthdate (B.C)",

    otp_descrip_p1: "an OTP has been sent to your regsitered mobile phone number. ",

    popup_login_error_title: "Information is invalid!",
    popup_login_error_content: "Invalid ID card.",
    popup_login_error_title_mobile: "Sorry",
    popup_login_error_content_mobile: "This mobile phone number is not registered on our system, please contact your investment consultant to update your mobile phone number.",

    popup_login_date_error_content: "Invalid birthdate",

    popup_otp_error_title: "Sorry",
    popup_otp_error_content: "Invalid OTP,  the verification is  failed",
    popup_otp_lock_content: "Please try again after 5 minutes.",
    
    otp_refCode: "ref. no.:",
    otp_remark: "If the registered mobile phone number is not your current one, please contact your investment consaltant to update your mobile phone number.",

    popup_error500_title: "Error",
    popup_error500_content: "Try again",

    popup_error_title: "Error",
    popup_error_content: "Try again",

    success: "Success Your information is valid",
    loading: "Please wait",

    btn_otp: "Request new OTP",
    btn_next: "Next",
    btn_again: "Please try again",
    btn_ok: "OK",
  },
};